var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFuelIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 3a.5.5 0 0 0-.5-.5h-5A.5.5 0 0 0 3 3v4a.5.5 0 0 0 .5.5h5A.5.5 0 0 0 9 7V3zM8 6.5H4v-3h4v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.736 3.545l-1.994-1a.496.496 0 0 0-.668.224.5.5 0 0 0 .225.67l.76.38c-.021.055-.047.112-.047.174 0 .65.488 1.2.988 1.408v6.092a.5.5 0 0 1-1 0v-4c0-1.208-1-2.217-2-2.45v-3.05A1.976 1.976 0 0 0 9.024 0h-6C1.92 0 1 .89 1 1.993v11.19l-.724.362a.5.5 0 0 0-.276.448v1.5c0 .276.248.507.524.507h11c.276 0 .476-.231.476-.507v-1.5a.5.5 0 0 0-.276-.448L11 13.184v-7.1c.5.208 1 .758 1 1.409v4c0 .827.673 1.5 1.5 1.5s1.5-.673 1.5-1.5v-7.5a.49.49 0 0 0-.264-.448zM11 15H1v-.698l.724-.362A.5.5 0 0 0 2 13.493v-11.5C2 1.44 2.472 1 3.024 1h6c.551 0 .976.441.976.993v11.5a.5.5 0 0 0 .276.447l.724.362V15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelIcon);
export default __webpack_public_path__ + "static/media/fuel_icon.163ef59a4d10a162aa0e30057946833e.svg";
export { ForwardRef as ReactComponent };